import Error, { ErrorOptions } from "./Error";

export { Error as WebinyError };
export default Error;
export { ErrorOptions };
